// extracted by mini-css-extract-plugin
module.exports = {"bottomAd_box":"bottomAd_box-3xVO3GjJ","bottomAd":"bottomAd-2Ft8rOZj"};